import { FunctionComponent } from 'react';
import { IconArrowLeft, IconArrowRight } from '@tocktix/pantry';
import { IconButton } from 'bento';
import { NavbarElementProps } from 'react-day-picker';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '4.8rem',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export const CalendarNavBar: FunctionComponent<React.PropsWithChildren<NavbarElementProps>> = ({
  labels,
  onNextClick,
  onPreviousClick,
  showNextButton,
  showPreviousButton,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <IconButton
        aria-label={labels.previousMonth}
        variant="text"
        disabled={!showPreviousButton}
        onClick={() => onPreviousClick()}
        color="subtle"
        data-testid="calendarbar-navbar-left"
      >
        <IconArrowLeft />
      </IconButton>
      <IconButton
        aria-label={labels.nextMonth}
        variant="text"
        disabled={!showNextButton}
        onClick={() => onNextClick()}
        color="subtle"
        data-testid="calendarbar-navbar-right"
      >
        <IconArrowRight />
      </IconButton>
    </div>
  );
};
